// ** React Imports
import { type ReactNode } from 'react';

// ** Types
import type { NavLink } from '../../types';
import { useCurrentUser } from '@erikdakoda/ui/hooks/useCurrentUser';

interface Props {
  navLink?: Pick<NavLink, 'roles'>;
  children: ReactNode;
}

const CanViewNavLink = (props: Props) => {
  const { children, navLink } = props;
  const { isUserLoading, user } = useCurrentUser();

  const userRole = !user || isUserLoading ? 'GUEST' : user.disableAdmin ? 'USER' : user.role;

  return navLink?.roles?.includes(userRole) ? children : null;
};

export default CanViewNavLink;
